import { WorkerPayloadTypes } from "@/constants";
import { DieTypes } from "@/constants/diceConfig";
import type { DieType, Manifest, ManifestNode } from "@/types";
import { isEmpty } from "lodash";

export const addScales = (
  manifests: Record<string, Manifest>,
  physicsWorker: Worker,
) => {
  const scales = Object.entries(manifests).reduce(
    (acc, [setId, manifest]) => {
      Object.entries(manifest)
        .filter(([k]) => Boolean(DieTypes[k as unknown as DieType]))
        .forEach(([key, v]) => {
          const value = v as ManifestNode;
          if (!value.scale) return;
          if (!acc[setId]) {
            acc[setId] = {};
          }

          acc[setId][key] = value.scale;
        });

      return acc;
    },
    {} as Record<string, Record<string, ManifestNode["scale"]>>,
  );

  if (!isEmpty(scales)) {
    physicsWorker.postMessage({
      type: WorkerPayloadTypes.Scales,
      payload: scales,
    });
  }
};
